import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Notification } from '../../../core/services/notification.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="fixed top-6 right-6 z-[9999] flex flex-col gap-3 pointer-events-none">
      <div *ngFor="let toast of notification.toasts()" 
           class="toast-card relative flex items-center gap-3 px-4 py-3 min-w-[300px] max-w-[400px] rounded-lg shadow-lg pointer-events-auto bg-[#1a1a1a] border border-[#2a2a2a] overflow-hidden"
           [class.animate-slide-in]="true">
        
        <!-- Status Icon -->
        <div class="flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-full"
             [ngClass]="{
               'bg-success/20 text-success': toast.type === 'success',
               'bg-danger/20 text-danger': toast.type === 'error',
               'bg-primary/20 text-primary': toast.type === 'info'
             }">
          <mat-icon class="text-[16px] w-[16px] h-[16px]">
            {{ toast.type === 'success' ? 'check' : toast.type === 'error' ? 'close' : 'info' }}
          </mat-icon>
        </div>

        <!-- Message -->
        <p class="flex-1 text-[13px] text-white m-0 leading-snug font-medium">
          {{ toast.message }}
        </p>

        <!-- Close Button -->
        <button (click)="notification.remove(toast.id)" 
                class="flex-shrink-0 flex items-center justify-center w-6 h-6 rounded text-[#888] hover:bg-white/10 hover:text-white transition-colors cursor-pointer outline-none">
          <mat-icon class="text-[16px] w-[16px] h-[16px]">close</mat-icon>
        </button>

        <!-- Progress Bar -->
        <div class="absolute bottom-0 left-0 h-[2px] bg-white/20 progress-bar-animate w-full"></div>
        <div class="absolute bottom-0 left-0 h-[2px] progress-bar-animate-fill w-full"
             [ngClass]="{
               'bg-success': toast.type === 'success',
               'bg-danger': toast.type === 'error',
               'bg-primary': toast.type === 'info'
             }"></div>
      </div>
    </div>
  `,
  styles: [`
    .animate-slide-in {
      animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    }

    .progress-bar-animate-fill {
      transform-origin: left;
      animation: progressDrain 4s linear forwards;
    }

    @keyframes slideIn {
      0% {
        opacity: 0;
        transform: translateX(100%) scale(0.95);
      }
      100% {
        opacity: 1;
        transform: translateX(0) scale(1);
      }
    }

    @keyframes progressDrain {
      0% {
        transform: scaleX(1);
      }
      100% {
        transform: scaleX(0);
      }
    }
  `]
})
export class ToastContainerComponent {
  constructor(public notification: Notification) {}
}
